<script setup lang="ts">
import { ref } from "vue";
const WrTechStackPile = defineAsyncComponent(
  () => import("~/components/molecules/WrTechStackPile.vue")
);

const { isDesktop, isMobile } = useDevice();

const Apps = [
  {
    title: "APPS",
    leftTitle: "Backend",
    tech: [
      {
        img: "/images/icons/laravel-icon.webp",
        text: "Laravel",
        imgWidth: "25",
        imgHeight: "26",
        link: "/services/frameworks/laravel-development-services",
      },
      {
        img: "/images/icons/adoni.webp",
        text: "Adonis",
        imgWidth: "27",
        imgHeight: "23",
        link: "/services/frameworks/adonisjs-development-services",
      },
      {
        img: "/images/icons/express.webp",
        text: "Express",
        imgWidth: "23",
        imgHeight: "25",
        link: "/services/frameworks/express-development-services",
      },
    ],
  },
  {
    leftTitle: "Frontend",
    tech: [
      {
        img: "/images/icons/vue-icon.webp",
        text: "Vue",
        imgWidth: "28",
        imgHeight: "24",
        link: "/services/frameworks/vuejs-development-services",
      },
      {
        img: "/images/icons/nuxt1.webp",
        text: "Nuxt ",
        imgWidth: "34",
        imgHeight: "23",
        link: "/services/frameworks/nuxtjs-development-services",
      },
      {
        img: "/images/icons/react.webp",
        text: "React",
        imgWidth: "29",
        imgHeight: "26",
        link: "/services/frameworks/reactjs-development-services",
      },
    ],
  },
  {
    leftTitle: "Database",
    tech: [
      {
        img: "/images/icons/mysql.webp",
        text: "MySQL",
        imgWidth: "27",
        imgHeight: "27",
        link: "/",
      },
      {
        text: "Rethink DB",
        img: "/images/icons/rethink.webp",
        imgWidth: "17",
        imgHeight: "27",
        link: "/",
      },
      {
        img: "/images/icons/mongo.webp",
        text: "Mongo DB",
        imgWidth: "14",
        imgHeight: "31",
        link: "/",
      },
      {
        img: "/images/icons/fauna.webp",
        text: "Fauna DB",
        imgWidth: "25",
        imgHeight: "27",
        link: "/",
      },
    ],
  },
];

const Api = [
  {
    title: "API",
    tech: [
      {
        img: "/images/icons/fastify.webp",
        text: "Fastify",
        imgWidth: "30",
        imgHeight: "19",
        link: "/",
      },
      {
        img: "/images/icons/restify.webp",
        text: "Restify",
        imgWidth: "21",
        imgHeight: "17",
        link: "/",
      },
      {
        img: "/images/icons/express.webp",
        text: "Express",
        imgWidth: "25",
        imgHeight: "27",
        link: "/services/frameworks/express-development-services",
      },
      {
        img: "/images/icons/lumen.webp",
        text: "Lumen",
        imgWidth: "14",
        imgHeight: "29",
        link: "/",
      },
      {
        img: "/images/icons/koa.webp",
        text: "Koa",
        imgWidth: "26",
        imgHeight: "24",
        link: "/",
      },
      {
        img: "/images/icons/hapi.webp",
        text: "Hapi",
        imgWidth: "31",
        imgHeight: "21",
        link: "/",
      },
    ],
  },
];

const Ios = [
  {
    title: "iOS",
    tech: [
      {
        img: "/images/icons/swift.webp",
        text: "Swift",
        imgWidth: "28",
        imgHeight: "25",
        link: "/",
      },
    ],
  },
];

const Android = [
  {
    title: "Android",
    tech: [
      {
        img: "/images/icons/dart.webp",
        text: "Dart",
        imgWidth: "23",
        imgHeight: "23",
        link: "/",
      },
      {
        img: "/images/icons/kotlin.webp",
        text: "Kotlin",
        imgWidth: "27",
        imgHeight: "24",
        link: "/",
      },
    ],
  },
];

const Hybrid = [
  {
    title: "Hybrid Apps Tech Stack",
    tech: [
      {
        img: "/images/icons/flutter.webp",
        text: "Flutter",
        imgWidth: "19",
        imgHeight: "23",
        link: "/services/mobility/flutter-app-development",
      },
      {
        img: "/images/icons/ionic.webp",
        text: "Ionic",
        imgWidth: "25",
        imgHeight: "25",
        link: "/services/mobility/ionic-app-development",
      },
      {
        img: "/images/icons/react.webp",
        text: "React Native",
        imgWidth: "26",
        imgHeight: "23",
        link: "/services/mobility/reactnative-app-development",
      },
    ],
  },
];

</script>

<template>
  <div class="relative text-[var(--foreground)]">
    <div class="relative w-full flex justify-center">
      <NuxtImg
        v-if="!isDesktop"
        alt="agile"
        :src="
          $colorMode.preference == 'dark'
            ? '/images/agile-dark.webp'
            : '/images/agile.webp'
        "
        width="777"
        height="458"
        class="z-20 relative mx-auto"
        preload
        loading="eager"
        format="webp"
      />
      <div
        v-if="isDesktop"
        class="relative overflow-hidden"
        :style="{
          width: isMobile ? '380px' : '1212px',
          height: isMobile ? '170px' : '729px',
        }"
      >
        <video
          ref="videoEl"
          preload="auto"
          width="1212"
          height="729"
          playsinline
          muted
          loop
          autoplay
          class="absolute inset-0 !-top-40 transition-opacity fade-transition"
        >
          <source src="/images/output_video.webm" type="video/webm" />
        </video>
      </div>
    </div>

    <div
      class="relative flex justify-center flex-col lg:flex-row md:justify-between gap-10 lg:gap-32 lg:*:w-1/2 mt-10 lg:-mt-56 lg:px-20"
    >
      <span
        class="size-[463px] dark:bg-[#47116B] bg-[#F6E9FF] rounded-full blur-[150px] absolute -top-40 -left-80"
      ></span>
      <span
        class="hidden dark:block size-[509px] bg-[#22206D99] rounded-full blur-[70px] absolute top-28 left-0"
      ></span>
      <span
        class="size-[463px] bg-[#F6E9FF] dark:bg-[#47116B] rounded-full blur-[150px] absolute top-96 left-full"
      ></span>
      <div>
        <h3
          class="font-semibold dark:font-normal text-[var(--foreground)] text-lg md:text-2xl text-center mb-8 before:content-none before:absolute relative before:border-t-2 before:border-r before:border-[var(--dashed-border)] before:bottom-9 before:h-[64px] before:rounded-3xl before:w-24 before:border-dashed before:rounded-br-none before:rounded-tl-none before:left-[7.1rem]"
        >
          Desktop Tech Stack
        </h3>

        <div class="flex gap-4 md:gap-12 justify-center">
          <div class="relative">
            <div
              v-if="isDesktop"
              class="absolute w-[200px] h-[290px] left-1/2 top-[90%] border-l border-b border-[var(--dashed-border)] rounded-br-none rounded-3xl border-dashed"
            ></div>
            <div
              v-for="technology in Apps"
              class="relative last:after:content-none after:content-[''] after:absolute after:bottom-[-90px] after:left-1/2 after:-translate-x-1/2 after:w-px after:h-[90px] after:border-l after:border-dashed after:border-[var(--dashed-border)] after:z-[-1]"
            >
              <WrTechStackPile
                :left-title="technology.leftTitle"
                :title="technology.title"
                :technologies="technology.tech"
              />
            </div>
          </div>
          <div>
            <WrTechStackPile
              v-for="technology in Api"
              :title="technology.title"
              :technologies="technology.tech"
            />
          </div>
        </div>
      </div>
      <div class="">
        <h3
          class="font-semibold dark:font-normal text-[var(--foreground)] text-lg md:text-2xl text-center mb-8 before:content-none before:absolute relative before:border-l-2 before:border-t-2 before:rounded-tr-none before:border-[var(--dashed-border)] before:bottom-9 before:h-[64px] before:rounded-3xl before:w-10 before:border-dashed before:rounded-bl-none before:right-[11.65rem]"
        >
          Mobile Tech Stack
        </h3>
        <div
          class="flex gap-x-4 md:gap-x-12 md:gap-y-20 flex-wrap justify-center max-w-lg mx-auto relative"
        >
          <div
            class="absolute top-[95px] left-1/2 -translate-x-1/2 h-[120px] w-[286px] max-w-1/2 border border-dashed border-[var(--dashed-border)] border-t-0 rounded-[25px] rounded-tl-none max-w-full z-[-1] after:content-[''] after:absolute after:left-1/2 after:-translate-x-1/2 after:top-full after:h-[30px] after:w-[10px] after:border-l after:border-dashed after:border-[var(--dashed-border)] after:z-[-1]"
          ></div>

          <div
            v-if="isDesktop"
            class="absolute w-[200px] h-[450px] right-1/2 top-[90%] border-r border-b border-[var(--dashed-border)] rounded-bl-none rounded-t-none rounded-3xl border-dashed"
          ></div>

          <WrTechStackPile
            v-for="technology in Ios"
            :title="technology.title"
            :technologies="technology.tech"
          />
          <WrTechStackPile
            v-for="technology in Android"
            :title="technology.title"
            :technologies="technology.tech"
          />
          <WrTechStackPile
            v-for="technology in Hybrid"
            :title="technology.title"
            :technologies="technology.tech"
            title-class="md:text-base"
          />
        </div>
      </div>
    </div>

    <div
      class="text-[var(--foreground)] max-w-max mx-auto lg:ml-auto lg:mr-28 mt-12 lg:-mt-24 xl:-mt-28 z-10 relative before:content-none lg:before:content-[''] before:absolute before:-bottom-20 before:border-dashed before:h-[152px] before:w-px before:border-l before:border-[var(--dashed-border)] before:left-[50%] xl:before:left-[42%]"
    >
      <h4
        class="text-[#A44AE1] dark:text-white text-lg md:text-2xl text-center mb-7 lg:absolute lg:top-10 lg:left-48 lg:text-left lg:font-semibold"
      >
        Automation <br v-if="isDesktop" class="" />
        Testing
      </h4>

      <NuxtImg
        :src="
          $colorMode.preference == 'dark'
            ? '/images/automation-dark.webp'
            : '/images/automation.webp'
        "
        class="z-10 relative"
        width="873"
        height="553"
        alt="automation testing"
        loading="lazy"
        format="webp"
      />
    </div>
  </div>
</template>

<style scoped>
.fade-transition {
  transition: opacity 0.6s ease;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.pointer-events-none {
  pointer-events: none !important;
}
</style>
